<script setup lang='ts'>
import { trans } from 'laravel-vue-i18n'
import { ref, onMounted, onUnmounted, inject, defineAsyncComponent } from 'vue'
// import SearchBar from "@/Components/SearchBar.vue"
import Image from '@/Components/Utils/Image.vue'
// import Popover from '@/Components/Popover.vue'
// import NotificationList from '@/Components/NotificationList/NotificationList.vue'
// import Profile from "@/Pages/Grp/Profile.vue"
import Popover from 'primevue/popover'
import Button from "@/Components/Utils/Button.vue"
import { layoutStructure } from "@/Composables/useLayoutStructure"

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faCircle } from '@fas'
import { faSignOut, faCog } from '@fal'
import { library } from '@fortawesome/fontawesome-svg-core'
import { Link, usePage } from '@inertiajs/vue3'
import LoadingIcon from '@/Components/Utils/LoadingIcon.vue'
library.add(faCircle, faSignOut, faCog)

/* const Profile = defineAsyncComponent(() => import("@/Pages/Grp/Profile.vue")) */


const props = defineProps<{
    urlPrefix: string
}>()

const layout = inject('layout', layoutStructure)

// const layoutStore = useLayoutStore()
const showSearchDialog = ref(false)
const isLoadingLogout = ref<string | null>(null)


onMounted(() => {
    if (typeof window !== 'undefined') {
        document.addEventListener('keydown', (event) => {

            if( ( isUserMac ? event.metaKey : event.ctrlKey ) && event.key === 'k') {
                event.preventDefault()
                showSearchDialog.value = !showSearchDialog.value
            }
        })
    }
})

onUnmounted(() => {
    document.removeEventListener('keydown', () => false)
})

const isUserMac = navigator.platform.includes('Mac')  // To check the user's Operating System

const _popover = ref(null)
</script>

<template>
    <!-- Avatar Group -->
    <div class="flex justify-between gap-x-2">
        <div class="flex items-center gap-x-0 sm:gap-x-4 sm:divide-x divide-gray-200">
            <!-- Button: Search -->
            <button v-if="false" @click="showSearchDialog = !showSearchDialog" id="search"
                class="h-7 w-fit flex items-center justify-center gap-x-3 ring-1 ring-gray-300 rounded-md px-3 text-gray-500 hover:bg-gray-200 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-gray-500">
                <span class="sr-only">{{ trans("Search") }}</span>
                <FontAwesomeIcon aria-hidden="true" size="sm" icon="fa-regular fa-search" />
                <div class="hidden whitespace-nowrap md:flex items-center justify-end text-gray-500/80 tracking-tight space-x-1">
                    <span v-if="isUserMac" class="ring-1 ring-gray-400 bg-gray-100 px-2 leading-none text-xl rounded">⌘</span>
                    <span v-else class="ring-1 ring-gray-400 bg-gray-100 px-2 py-0.5 text-xs rounded">Ctrl</span>
                    <span class="ring-1 ring-gray-400 bg-gray-100 px-1.5 py-0.5 text-xs rounded">K</span>
                </div>
                <!-- <SearchBar v-model="showSearchDialog" /> -->
            </button>

            <div class="flex items-center gap-x-2">
                <!-- <div @click="() => layout.stackedComponents.push({ component: Profile, data: { currentTab: 'todo' }})">
                    <Button label="To do" size="xs" :style="'tertiary'" />
                </div> -->

                <div @click="(e) => _popover?.toggle(e)" class="select-none cursor-pointer font-bold text-sky-500">{{ usePage().props.auth?.user?.name }}</div>
                <Popover ref="_popover">
                    <div class="flex flex-col gap-2 w-44">
                        <Link
                            :href="route('profile.edit')"
                            as="a"
                            class="w-full flex items-center gap-2 hover:bg-sky-100 px-2 py-1 rounded cursor-pointer"
                            @start="() => isLoadingLogout = 'profile'"
                            @finish="() => isLoadingLogout = null"
                        >
                            <LoadingIcon v-if="isLoadingLogout === 'profile'" class='text-gray-400' />
                            <FontAwesomeIcon v-else icon='fal fa-cog' class='text-gray-400' fixed-width aria-hidden='true' />
                            Setting
                        </Link>

                        <Link
                            :href="route('auth.logout')"
                            as="a"
                            class="w-full flex items-center gap-2 hover:bg-sky-100 px-2 py-1 rounded cursor-pointer"
                            @start="() => isLoadingLogout = 'logout'"
                            @error="() => isLoadingLogout = null"
                        >
                            <LoadingIcon v-if="isLoadingLogout === 'logout'" class='text-gray-400' />
                            <FontAwesomeIcon v-else icon='fal fa-sign-out' class='text-gray-400' fixed-width aria-hidden='true' />
                            Logout
                        </Link>
                    </div>
                </Popover>


                <!-- Button: Profile -->
                <!-- <div @click="layout.stackedComponents.push({ component: Profile})"
                    class="flex max-w-xs overflow-hidden items-center rounded-full bg-gray-100 text-sm focus:outline-none focus:ring-2 focus:ring-gray-500 cursor-pointer">
                    <span class="sr-only">{{ trans("Open user menu") }}</span>
                    <Image class="h-8 w-8 rounded-full" :src="layout.user.avatar_thumbnail" alt="" />
                </div> -->
            </div>
        </div>

    </div>
</template>
